export default __webpack_public_path__ + "static/media/group-icon.5f1a3127.png";